import React from "react";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import FormatListNumberedRoundedIcon from "@mui/icons-material/FormatListNumberedRounded";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import { EQueueDispatchMode } from "../enums/call-flow.enum";

export const FLOW_OPTIONS: {
    key: EQueueDispatchMode;
    label: string;
    description: string;
    bestFor: string;
    icon: React.ReactNode;
    disabled: boolean;
}[] = [
        {
            key: EQueueDispatchMode.RING_ALL,
            label: "Ring all",
            disabled: false,
            description: "Call all available team members at the same time.",
            bestFor: "small teams, fast pickup",
            icon: <GroupRoundedIcon sx={{ fontSize: 20 }} />,
        },
        {
            key: EQueueDispatchMode.PRIORITY_ORDER,
            label: "Priority order",
            disabled: false,
            description: "Call team members one by one based on a custom priority.",
            bestFor: "reception, structured escalation",
            icon: <FormatListNumberedRoundedIcon sx={{ fontSize: 20 }} />,
        },
        {
            key: EQueueDispatchMode.CUSTOM_FLOW,
            label: "Custom flow",
            disabled: true,
            description: "Build a more advanced routing setup for your business.",
            bestFor: "advanced teams, special logic",
            icon: <AccountTreeRoundedIcon sx={{ fontSize: 20 }} />,
        },
    ];